import { Check, Clock, Play } from 'lucide-react';

/** Maintenance-specific status/priority helpers + cost math.
 *  Kept separate from cleaning/utils to avoid coupling — the two views
 *  will diverge (e.g. priority is maintenance-only). */

export const getStatusIcon = (status) => {
  switch (status) {
    case 'completed':
      return <Check className="h-4 w-4 text-emerald-600" />;
    case 'in_progress':
      return <Play className="h-4 w-4 text-blue-600" />;
    default:
      return <Clock className="h-4 w-4 text-amber-600" />;
  }
};

export const getStatusBadge = (status) => {
  switch (status) {
    case 'completed':
      return 'bg-emerald-50 text-emerald-700 border-emerald-100';
    case 'in_progress':
      return 'bg-blue-50 text-blue-700 border-blue-100';
    default:
      return 'bg-amber-50 text-amber-700 border-amber-100';
  }
};

export const getPriorityBadge = (priority) => {
  switch (priority) {
    case 'urgent':
      return 'bg-red-100 text-red-700 border-red-200';
    case 'high':
      return 'bg-orange-100 text-orange-700 border-orange-200';
    case 'medium':
      return 'bg-amber-100 text-amber-700 border-amber-200';
    default:
      return 'bg-slate-100 text-slate-700 border-slate-200';
  }
};

export const calculateLaborCost = (task) => {
  if (!task?.hours_worked || !task?.hourly_rate) return 0;
  return task.hours_worked * task.hourly_rate;
};

export const calculateTotalCost = (task) => {
  const materials = task?.estimated_cost || 0;
  return materials + calculateLaborCost(task);
};

export const PRIORITY_ORDER = { urgent: 0, high: 1, medium: 2, low: 3 };
